import type { RouteResource } from 'react-resource-router';

import { fg } from '@atlaskit/platform-feature-flags';
import {
	alertGroupingStateResource,
	type AlertGroupFeatureStateResponse,
} from '@atlassian/aiops-group-common';
import { eocCommonResources, type UserResourceType } from '@atlassian/eoc-resources';

import type { UiPreferences, SavedSearches } from '../../common/types';
import { noiseReductionMetricsResource } from '../alert-noise-metrics/resource';
import type { NoisyReductionMetrics } from '../alert-noise-metrics/types';
import { savedSearchesResource } from '../saved-searches/resources';
import { uiPreferencesResource } from '../ui-preferences/resources';

export const resources = (): (
	| RouteResource<UiPreferences>
	| RouteResource<UserResourceType>
	| RouteResource<NoisyReductionMetrics>
	| RouteResource<SavedSearches>
	| RouteResource<AlertGroupFeatureStateResponse>
)[] => [
	uiPreferencesResource,
	savedSearchesResource,
	alertGroupingStateResource,
	...(fg('snr-noise-filter') ? [noiseReductionMetricsResource] : []),
	...eocCommonResources(),
];
